<template>
  <CSidebar 
    fixed 
    :minimize="minimize"
    :show="show"
    colorScheme="light"
    @update:show="(value) => $store.commit('set', ['sidebarShow', value])"
  >
    <CSidebarBrand class="d-md-down-none" style="background: white;">
      <img src="../assets/iblogo.png" class="c-sidebar-brand-full" height="35">
      <img src="../assets/ibicon.png" class="c-sidebar-brand-minimized" height="25">
    </CSidebarBrand>

    <CRenderFunction flat :content-to-render="$options.nav"/>
    <CSidebarMinimizer
      class="d-md-down-none"
      @click.native="$store.commit('set', ['sidebarMinimize', !minimize])"
    />
  </CSidebar>
</template>

<script>
import nav from './_nav'

export default {
  name: 'TheSidebar',
  nav,
  computed: {
    show () {
      return this.$store.state.sidebarShow 
    },
    minimize () {
      return this.$store.state.sidebarMinimize 
    }
  }
}
</script>

<style scoped>
.sidebar-black-text .c-sidebar-nav-link,
.sidebar-black-text .c-sidebar-nav-dropdown-toggle {
  color: black !important;
}
</style>
